<template>
<div class="chapter">
<div class="inner_page">
<p class="pagehead1"><a href="#/contents#ack"><b>Acknowledgements</b></a></p>
<p class="image0"><img alt="image" src="images/image1.jpg"/></p>
<p class="normal">Sincerest thanks is due to the following individuals and websites for support in compiling the illustration scheme for this book: Tim Addis, Louis Henwood, Bill Lazell, Peter Norman, Rita Lyons, Jennie Crawford, Mr C.A. Rowntree, <a href="http://www.killifish.f9.co.uk" target="_blank">www.killifish.f9.co.uk</a>, <a href="http://www.Louishenwood.com" target="_blank">www.Louishenwood.com</a></p>
<p class="bodytext">The publisher has tried without success to contact the copyright holders of some of the illustrations, and would be pleased to hear from any untraced source.</p>
<p class="bodytext">The author would like to thank the following for granting him permission to use coyright material within their possession: Mrs M. Rogers, Mr C.A. Rowntree, Mr John Blundell, Mrs Blois-Brooke and the Imperial War Museum. Every effort has been made to trace all copyright holders, but some have been elusive. If any have been overlooked, the Publishers will be pleased to make the necessary acknowledgements at the first opportunity.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?c1ff4d0a